import { render, staticRenderFns } from "./MFooter.vue?vue&type=template&id=021580a4&scoped=true"
import script from "./MFooter.vue?vue&type=script&lang=js"
export * from "./MFooter.vue?vue&type=script&lang=js"
import style0 from "./MFooter.vue?vue&type=style&index=0&id=021580a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021580a4",
  null
  
)

export default component.exports